function formatAmount(value) {
  const num = Number(value);
  if (Number.isNaN(num)) return "0.00";
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function formatWhole(value) {
  const num = Number(value);
  if (Number.isNaN(num)) return "0";
  return num.toLocaleString("en-US");
}

/** Build the headline shown on the offer card (e.g. "15% Bonus upto 1000.00 INR (Min. deposit 2000 INR)"). */
function buildOfferDetail(offer) {
  const parts = [];

  if (Number(offer.percentage) > 0) {
    parts.push(`${offer.percentage}% Bonus`);
    if (Number(offer.max_bonus_amount) > 0) {
      parts.push(`upto ${formatAmount(offer.max_bonus_amount)} INR`);
    }
  } else if (Number(offer.amount) > 0) {
    parts.push(`${formatAmount(offer.amount)} INR Bonus`);
  } else {
    parts.push(offer.description || "Bonus");
  }

  let detail = parts.join(" ");
  if (Number(offer.min_deposit) > 0) {
    detail += `(Min. deposit ${formatWhole(offer.min_deposit)} INR)`;
  }
  return detail;
}

/** Map bonus offer API payload to the shape used by the deposit UI. */
export function normalizeBonusOffer(offer = {}) {
  return {
    ...offer,
    displayName: offer.name || "Bonus",
    displayDetail: buildOfferDetail(offer),
    templateId:
      offer.bonus_template_id || offer.template_id || offer.id || "",
  };
}

export function normalizeBonusOffers(offers = []) {
  if (!Array.isArray(offers)) return [];
  return offers.map(normalizeBonusOffer);
}
